import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=53538966"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports